import { useAuth } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A1826]" data-testid="auth-loading">
        <Loader2 className="w-8 h-8 text-[#EA7B2B] animate-spin" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
